import React, { useState, useEffect } from "react";
import JsonData from "../data/data.json";
import { Navigation } from "../components/navigation";
import { Header } from "../components/header";
import { Features } from "../components/features";
import { About } from "../components/about";
import { Services } from "../components/services";
import { Gallery } from "../components/gallery";
import { Contact } from "../components/contact";
import Partners from "../components/Partners";
import ScrollAnimation from "react-animate-on-scroll";
import Label from "../components/Label";

function LandingPage(props) {
  const [landingPageData, setLandingPageData] = useState({});
  const [projects, setProjects] = useState();
  useEffect(() => {
    setLandingPageData(JsonData);

    const proj = JsonData.Gallery.slice(4, 13);

    setProjects(proj);
  }, []);
  return (
    <>
      <Navigation />
      <Header data={landingPageData.Header} />
      <Features data={landingPageData.Features} />
      <Label />
      <About data={landingPageData.About} />
      <Partners />
      <ScrollAnimation animateIn="fadeInRight">
        <Services data={landingPageData.Services} />
      </ScrollAnimation>
      <ScrollAnimation animateIn="fadeIn">
        <Gallery data={projects} />
      </ScrollAnimation>

      {/* <Testimonials data={landingPageData.Testimonials} /> */}
      {/* <Team data={landingPageData.Team} /> */}
      <Contact data={landingPageData.Contact} />
    </>
  );
}

export default LandingPage;
